export const footerMoreLinks = {
  'fr-ru': [
    {
      title: 'более',
      items: [
        {
          href: 'https://www.wingie.fr/contact/',
          title: 'Контакты',
        },
        {
          href: 'https://www.wingie.fr/faq/',
          title: 'Часто задаваемые вопросы',
        },

        {
          href: 'https://www.wingie.fr/about-us/',
          title: 'О нас',
        },
        {
          href: 'https://www.wingie.fr/privacy/',
          title: 'Конфиденциальность',
        },
        {
          href: 'https://www.wingie.fr/terms-and-conditions/',
          title: 'Условия и положения',
        },
        {
          href: 'https://www.wingie.fr/awards/',
          title: 'Наши награды',
        },
      ],
    },
  ],
  'fr-en': [
    {
      title: 'More',
      items: [
        {
          href: 'https://www.wingie.fr/en/contact/',
          title: 'Contact',
        },
        {
          href: 'https://www.wingie.fr/en/faq/',
          title: 'Frequently Asked Questions',
        },

        {
          href: 'https://www.wingie.fr/en/about-us/',
          title: 'About us',
        },
        {
          href: 'https://www.wingie.fr/en/privacy/',
          title: 'Privacy',
        },
        {
          href: 'https://www.wingie.fr/en/terms-and-conditions/',
          title: 'Terms and Conditions',
        },
        {
          href: 'https://www.wingie.fr/en/awards/',
          title: 'Our Awards',
        },
      ],
    },
  ],
  'fr-es': [
    {
      title: 'Más',
      items: [
        {
          href: 'https://www.wingie.fr/es/contacto/',
          title: 'Contacto',
        },
        {
          href: 'https://www.wingie.fr/es/preguntas-frecuentes/',
          title: 'Preguntas más frecuentes',
        },

        {
          href: 'https://www.wingie.fr/es/acerca-de-nosotros/',
          title: 'Sobre nosotros',
        },
        {
          href: 'https://www.wingie.fr/es/privacidad/',
          title: 'Privacidad',
        },
        {
          href: 'https://www.wingie.fr/es/terminos-y-condiciones/',
          title: 'Términos y condiciones de uso',
        },
        {
          href: 'https://www.wingie.fr/es/awards/',
          title: 'Nuestros premios',
        },
      ],
    },
  ],
  'fr-de': [
    {
      title: 'Mehr',
      items: [
        {
          href: 'https://www.wingie.fr/de/kontakt/',
          title: 'Kontakt',
        },
        {
          href: 'https://www.wingie.fr/de/faq/',
          title: 'Häufig gestellte Fragen - Wingie',
        },

        {
          href: 'https://www.wingie.fr/de/uber-uns/',
          title: 'Über uns',
        },
        {
          href: 'https://www.wingie.fr/de/datenschutz/',
          title: 'Datenschutz & Cookies',
        },
        {
          href: 'https://www.wingie.fr/de/allgemeine-geschaeftsbedingungen/',
          title: 'Allgemeine Geschäftsbedingungen',
        },
        {
          href: 'https://www.wingie.fr/de/awards/',
          title: 'Unsere Auszeichnungen',
        },
      ],
    },
  ],
  'fr-ar': [
    {
      title: 'أكثر',
      items: [
        {
          href: 'https://www.wingie.fr/ar/contact/',
          title: 'التواصل',
        },
        {
          href: 'https://www.wingie.fr/ar/faq/',
          title: 'الأسئلة المتكررة',
        },
        {
          href: 'https://www.wingie.fr/ar/about-us/',
          title: 'تعرّف علينا',
        },
        {
          href: 'https://www.wingie.fr/ar/privacy/',
          title: 'الخصوصية - وينجي',
        },
        {
          href: 'https://www.wingie.fr/ar/terms-and-conditions/',
          title: 'شروط الاستخدام',
        },
        {
          href: 'https://www.wingie.fr/ar/awards/',
          title: 'جوائزنا',
        },
      ],
    },
  ],
  'fr-it': [
    {
      title: 'Di più',
      items: [
        { href: 'https://www.wingie.fr/it/contact/', title: 'Contatti' },
        // { href: 'https://www.wingie.fr/it/faq/', title: 'Domande frequenti' },

        { href: 'https://www.wingie.fr/it/about-us/', title: 'Chi siamo' },
        { href: 'https://www.wingie.fr/it/privacy/', title: 'Privacy' },
        { href: 'https://www.wingie.fr/it/terms-and-conditions/', title: 'Termini e condizioni' },
        { href: 'https://www.wingie.fr/it/awards/', title: 'I nostri premi' },
      ],
    },
  ],
  'fr-fr': [
    {
      title: 'Plus',
      items: [
        { title: 'Contact', href: 'https://www.wingie.fr/contact/' },
        // { title: 'Questions fréquemment posées', href: 'https://www.wingie.fr/faq/' },

        { title: 'À propos de nous', href: 'https://www.wingie.fr/about-us/' },
        { title: 'Confidentialité', href: 'https://www.wingie.fr/privacy/' },
        { title: 'Termes et conditions', href: 'https://www.wingie.fr/terms-and-conditions/' },
        { title: 'Nos récompenses', href: 'https://www.wingie.fr/awards/' },
      ],
    },
  ],
  'fr-pt': [
    {
      title: 'Mais',
      items: [
        { href: 'https://www.wingie.fr/pt/contact/', title: 'Contato' },
        // { href: 'https://www.wingie.fr/pt/faq/', title: 'Perguntas frequentes' },

        { href: 'https://www.wingie.fr/pt/about-us/', title: 'Sobre nós' },
        { href: 'https://www.wingie.fr/pt/privacy/', title: 'Privacidade' },
        { href: 'https://www.wingie.fr/pt/terms-and-conditions/', title: 'Termos e condições' },
        { href: 'https://www.wingie.fr/pt/awards/', title: 'Nossos prêmios' },
      ],
    },
  ],
  'fr-ro': [
    {
      title: 'Mai mult',
      items: [
        { href: 'https://www.wingie.fr/ro/contact/', title: 'Contact' },
        // { href: 'https://www.wingie.fr/ro/faq/', title: 'Întrebări frecvente' },

        { href: 'https://www.wingie.fr/ro/about-us/', title: 'Despre noi' },
        { href: 'https://www.wingie.fr/ro/privacy/', title: 'Confidențialitate' },
        { href: 'https://www.wingie.fr/ro/terms-and-conditions/', title: 'Termeni și condiții' },
        { href: 'https://www.wingie.fr/ro/awards/', title: 'Premiile noastre' },
      ],
    },
  ],
  'fr-pl': [
    {
      title: 'Więcej',
      items: [
        { href: 'https://www.wingie.fr/pl/contact/', title: 'Kontakt' },
        // { href: 'https://www.wingie.fr/pl/faq/', title: 'Często zadawane pytania' },

        { href: 'https://www.wingie.fr/pl/about-us/', title: 'O nas' },
        { href: 'https://www.wingie.fr/pl/privacy/', title: 'Prywatność' },
        { href: 'https://www.wingie.fr/pl/terms-and-conditions/', title: 'Regulamin' },
        { href: 'https://www.wingie.fr/pl/awards/', title: 'Nasze nagrody' },
      ],
    },
  ],
  'fr-lt': [
    {
      title: 'Daugiau',
      items: [
        { href: 'https://www.wingie.fr/lt/contact/', title: 'Kontaktai' },
        // { href: 'https://www.wingie.fr/lt/faq/', title: 'Dažnai užduodami klausimai' },

        { href: 'https://www.wingie.fr/lt/about-us/', title: 'Apie mus' },
        { href: 'https://www.wingie.fr/lt/privacy/', title: 'Privatumas' },
        { href: 'https://www.wingie.fr/lt/terms-and-conditions/', title: 'Taisyklės ir sąlygos' },
        { href: 'https://www.wingie.fr/lt/awards/', title: 'Mūsų apdovanojimai' },
      ],
    },
  ],
  'fr-uz': [
    {
      title: "Ko'proq",
      items: [
        { href: 'https://www.wingie.fr/uz/contact/', title: 'Aloqa' },
        // { href: 'https://www.wingie.fr/uz/faq/', title: "Tez-tez so'raladigan savollar" },

        { href: 'https://www.wingie.fr/uz/about-us/', title: 'Biz haqimizda' },
        { href: 'https://www.wingie.fr/uz/privacy/', title: 'Maxfiylik' },
        { href: 'https://www.wingie.fr/uz/terms-and-conditions/', title: 'Shartlar va qoidalar' },
        { href: 'https://www.wingie.fr/uz/awards/', title: 'Bizning mukofotlarimiz' },
      ],
    },
  ],
  'fr-sr': [
    {
      title: 'Више',
      items: [
        { href: 'https://www.wingie.fr/sr/contact/', title: 'Контакт' },
        // { href: 'https://www.wingie.fr/sr/faq/', title: 'Често постављана питања' },

        { href: 'https://www.wingie.fr/sr/about-us/', title: 'О нама' },
        { href: 'https://www.wingie.fr/sr/privacy/', title: 'Приватност' },
        { href: 'https://www.wingie.fr/sr/terms-and-conditions/', title: 'Услови коришћења' },
        { href: 'https://www.wingie.fr/sr/awards/', title: 'Наша признања' },
      ],
    },
  ],
  'fr-ky': [
    {
      title: 'Көбүрөөк',
      items: [
        { href: 'https://www.wingie.fr/ky/contact/', title: 'Байланыш' },
        // { href: 'https://www.wingie.fr/ky/faq/', title: 'Көп берилүүчү суроолор' },

        { href: 'https://www.wingie.fr/ky/about-us/', title: 'Биз жөнүндө' },
        { href: 'https://www.wingie.fr/ky/privacy/', title: 'Купуялык' },
        { href: 'https://www.wingie.fr/ky/terms-and-conditions/', title: 'Шарттар жана эрежелер' },
        { href: 'https://www.wingie.fr/ky/awards/', title: 'Биздин сыйлыктар' },
      ],
    },
  ],
  'fr-tg': [
    {
      title: 'Бештар',
      items: [
        { href: 'https://www.wingie.fr/tg/contact/', title: 'Алоқа' },
        // { href: 'https://www.wingie.fr/tg/faq/', title: 'Саволҳои зуд-зуд пурсида мешаванда' },

        { href: 'https://www.wingie.fr/tg/about-us/', title: 'Дар бораи мо' },
        { href: 'https://www.wingie.fr/tg/privacy/', title: 'Махфият' },
        { href: 'https://www.wingie.fr/tg/terms-and-conditions/', title: 'Шартҳо ва қоидаҳо' },
        { href: 'https://www.wingie.fr/tg/awards/', title: 'Мукофотҳои мо' },
      ],
    },
  ],
  'fr-kk': [
    {
      title: 'Көбірек',
      items: [
        { href: 'https://www.wingie.fr/kk/contact/', title: 'Байланыс' },
        // { href: 'https://www.wingie.fr/kk/faq/', title: 'Жиі қойылатын сұрақтар' },

        { href: 'https://www.wingie.fr/kk/about-us/', title: 'Біз туралы' },
        { href: 'https://www.wingie.fr/kk/privacy/', title: 'Құпиялық' },
        { href: 'https://www.wingie.fr/kk/terms-and-conditions/', title: 'Шарттар мен ережелер' },
        { href: 'https://www.wingie.fr/kk/awards/', title: 'Біздің марапаттарымыз' },
      ],
    },
  ],
  'fr-nl': [
    {
      title: 'Meer',
      items: [
        { href: 'https://www.wingie.fr/nl/contact/', title: 'Contact' },
        // { href: 'https://www.wingie.fr/nl/faq/', title: 'Veelgestelde vragen' },

        { href: 'https://www.wingie.fr/nl/about-us/', title: 'Over ons' },
        { href: 'https://www.wingie.fr/nl/privacy/', title: 'Privacy' },
        { href: 'https://www.wingie.fr/nl/terms-and-conditions/', title: 'Algemene voorwaarden' },
        { href: 'https://www.wingie.fr/nl/awards/', title: 'Onze awards' },
      ],
    },
  ],
  'fr-ja': [
    {
      title: 'もっと',
      items: [
        { title: 'お問い合わせ', href: 'https://www.wingie.fr/ja/contact/' },
        { title: 'よくある質問', href: 'https://www.wingie.fr/en/faq/' },
        { title: '会社概要', href: 'https://www.wingie.fr/ja/about-us/' },
        { title: 'プライバシーポリシー', href: 'https://www.wingie.fr/ja/privacy/' },
        { title: '利用規約', href: 'https://www.wingie.fr/ja/terms-and-conditions/' },
        { title: '受賞歴', href: 'https://www.wingie.fr/ja/awards/' },
      ],
    },
  ],
  'fr-zh': [
    {
      title: '更多',
      items: [
        { title: '联系方式', href: 'https://www.wingie.fr/zh/contact/' },
        { title: '常见问题', href: 'https://www.wingie.fr/en/faq/' },
        { title: '关于我们', href: 'https://www.wingie.fr/zh/about-us/' },
        { title: '隐私政策', href: 'https://www.wingie.fr/zh/privacy/' },
        { title: '条款和条件', href: 'https://www.wingie.fr/zh/terms-and-conditions/' },
        { title: '我们的奖项', href: 'https://www.wingie.fr/zh/awards/' },
      ],
    },
  ],
  'fr-ko': [
    {
      title: '더보기',
      items: [
        { title: '연락처', href: 'https://www.wingie.fr/ko/contact/' },
        { title: '자주 묻는 질문', href: 'https://www.wingie.fr/en/faq/' },
        { title: '회사 소개', href: 'https://www.wingie.fr/ko/about-us/' },
        { title: '개인정보처리방침', href: 'https://www.wingie.fr/ko/privacy/' },
        { title: '이용약관', href: 'https://www.wingie.fr/ko/terms-and-conditions/' },
        { title: '수상 내역', href: 'https://www.wingie.fr/ko/awards/' },
      ],
    },
  ],
  'fr-hi': [
    {
      title: 'अधिक',
      items: [
        { title: 'संपर्क करें', href: 'https://www.wingie.fr/hi/contact/' },
        { title: 'सामान्य प्रश्न', href: 'https://www.wingie.fr/en/faq/' },
        { title: 'हमारे बारे में', href: 'https://www.wingie.fr/hi/about-us/' },
        { title: 'गोपनीयता', href: 'https://www.wingie.fr/hi/privacy/' },
        { title: 'नियम और शर्तें', href: 'https://www.wingie.fr/hi/terms-and-conditions/' },
        { title: 'हमारे पुरस्कार', href: 'https://www.wingie.fr/hi/awards/' },
      ],
    },
  ],
  'fr-ta': [
    {
      title: 'மேலும்',
      items: [
        { title: 'தொடர்பு', href: 'https://www.wingie.fr/ta/contact/' },
        { title: 'அடிக்கடி கேட்கப்படும் கேள்விகள்', href: 'https://www.wingie.fr/en/faq/' },
        { title: 'எங்கள் பற்றி', href: 'https://www.wingie.fr/ta/about-us/' },
        { title: 'தனியுரிமை', href: 'https://www.wingie.fr/ta/privacy/' },
        { title: 'விதிமுறைகள்', href: 'https://www.wingie.fr/ta/terms-and-conditions/' },
        { title: 'எங்கள் விருதுகள்', href: 'https://www.wingie.fr/ta/awards/' },
      ],
    },
  ],
  'fr-th': [
    {
      title: 'เพิ่มเติม',
      items: [
        { title: 'ติดต่อเรา', href: 'https://www.wingie.fr/th/contact/' },
        { title: 'คำถามที่พบบ่อย', href: 'https://www.wingie.fr/en/faq/' },
        { title: 'เกี่ยวกับเรา', href: 'https://www.wingie.fr/th/about-us/' },
        { title: 'นโยบายความเป็นส่วนตัว', href: 'https://www.wingie.fr/th/privacy/' },
        { title: 'ข้อกำหนดและเงื่อนไข', href: 'https://www.wingie.fr/th/terms-and-conditions/' },
        { title: 'รางวัลของเรา', href: 'https://www.wingie.fr/th/awards/' },
      ],
    },
  ],
  'fr-ur': [
    {
      title: 'مزید',
      items: [
        { title: 'رابطہ کریں', href: 'https://www.wingie.fr/ur/contact/' },
        { title: 'عمومی سوالات', href: 'https://www.wingie.fr/en/faq/' },
        { title: 'ہمارے بارے میں', href: 'https://www.wingie.fr/ur/about-us/' },
        { title: 'رازداری', href: 'https://www.wingie.fr/ur/privacy/' },
        { title: 'شرائط و ضوابط', href: 'https://www.wingie.fr/ur/terms-and-conditions/' },
        { title: 'ہمارے اعزازات', href: 'https://www.wingie.fr/ur/awards/' },
      ],
    },
  ],
  'fr-ka': [
    {
      title: 'მეტი',
      items: [
        { title: 'კონტაქტი', href: 'https://www.wingie.fr/ka/contact/' },
        { title: 'ხშირად დასმული კითხვები', href: 'https://www.wingie.fr/en/faq/' },
        { title: 'ჩვენ შესახებ', href: 'https://www.wingie.fr/ka/about-us/' },
        { title: 'კონფიდენციალურობა', href: 'https://www.wingie.fr/ka/privacy/' },
        { title: 'წესები და პირობები', href: 'https://www.wingie.fr/ka/terms-and-conditions/' },
        { title: 'ჩვენი ჯილდოები', href: 'https://www.wingie.fr/ka/awards/' },
      ],
    },
  ],
}
